export default __webpack_public_path__ + "static/media/dropdown-usage.9f7f5a2a.svg";